import { AccessIs, hasAnyAccess } from "helper/access-permission";

export const ADMIN_EQUIVALENT_ROLES = ["ADMIN", "CONSULTOR", "SUPORTE", "DESENVOLVEDOR"];

export function hasAdminEquivalentRole(role: string[] | undefined | null): boolean {
  if (!role) return false;
  return role.some((r) => ADMIN_EQUIVALENT_ROLES.includes(r));
}

export const PURCHASE_LINK_MANAGER_ROLES = ["ADMIN", "SUPORTE"];

export function canManagePurchaseLinks(role: string[] | undefined | null): boolean {
  if (!role) return false;
  return role.some((r) => PURCHASE_LINK_MANAGER_ROLES.includes(r));
}

export function deveExibirBotaoVinculoLoja(
  access: string[] | undefined | null,
  fluxoPedidosHabilitado: boolean | null | undefined
): boolean {
  return hasAnyAccess(access, [AccessIs.vinculoLoja]) && fluxoPedidosHabilitado === true;
}

export const ROLES_FLUXO_APROVACAO_PEDIDO = ['COMPRAS_OPERACIONAL', 'COMPRAS_GESTOR', 'ADMIN'];

export function hasAcessoFluxoAprovacaoPedido(access: string[] | undefined | null): boolean {
  return hasAnyAccess(access, [AccessIs.operarFluxoAprovacaoPedido]);
}
